import { render } from "./ServiceSection.vue?vue&type=template&id=1cd7313f&scoped=true"
const script = {}

import "./ServiceSection.vue?vue&type=style&index=0&id=1cd7313f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1cd7313f"]])

export default __exports__